import { render } from "./PromotionSummary.vue?vue&type=template&id=23e00cd9"
import script from "./PromotionSummary.vue?vue&type=script&lang=js"
export * from "./PromotionSummary.vue?vue&type=script&lang=js"

import "./PromotionSummary.vue?vue&type=style&index=0&id=23e00cd9&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__